import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import groupBy from 'lodash/groupBy';
import map from 'lodash/map';
import sortBy from 'lodash/sortBy';
import { FormattedMessage, injectIntl } from 'react-intl';
import { Link } from 'react-router';
import { getStateForAbbreviation } from '../../utils/location-utils';
import Container from '../../components/Container';
import Header from '../../components/Header';
import SidebarWrapper from '../../components/SidebarWrapper';
import Toast from '../../components/Toast';
import PageTitle from '../../components/PageTitle';
import RepVisitsTravelPlanNoResults from './repvisits-travel-plan-no-results';
import RepVisitsTravelPlanResults from './repvisits-travel-plan-results';
import RepVisitsCalendarEventDetailsSideBar from '../RepVisitsCalendarEventDetailsSideBar';
import messages from './messages';

import './styles.css';
import Loader from '../../components/Loader';

export const getTravelPlans = (repVisitsTravelPlans) => {
  let travelPlans = groupBy(repVisitsTravelPlans, (repVisitsTravelPlan) => {
    const state = get(repVisitsTravelPlan, 'address.field_hs_elna_state_latest', '');
    return getStateForAbbreviation(state);
  });
  travelPlans = map(travelPlans, (value, key) => ({ state: key, institutions: value }));
  travelPlans = sortBy(travelPlans, 'state');
  return travelPlans;
};

class RepVisitsTravelPlan extends React.PureComponent {
  static propTypes = {
    intl: PropTypes.object,
    closeSideBar: PropTypes.func,
    showSideBar: PropTypes.func,
    viewer: PropTypes.shape({
      repVisitsTravelPlan: PropTypes.array,
    }),
    data: PropTypes.shape({
      loading: PropTypes.bool.isRequired,
    }),
    removeTravelPlan: PropTypes.func.isRequired,
  };

  static defaultProps = {
    viewer: {
      repVisitsTravelPlan: [],
    },
    data: {
      loading: true,
    },
  };

  state = {
    notification: null,
    sidebarVisible: false,
    selectedEvent: null,
  };

  successNotification =
    <Toast
      active
      title=""
      kind="success"
      description={this.props.intl.formatMessage(messages.successRemovedMessage)}
      onDeactivate={() => this.setState({ notification: null })}
    />;

  failureNotification =
    <Toast
      active
      title=""
      kind="error"
      description={this.props.intl.formatMessage(messages.failureRemovedMessage)}
      onDeactivate={() => this.setState({ notification: null })}
    />;

  displayNotification = (isSuccess) => {
    if (isSuccess) {
      this.setState({ notification: this.successNotification });
    } else {
      this.setState({ notification: this.failureNotification });
    }
  };

  closeSideBar = () => {
    if (this.state.sidebarVisible) {
      this.setState({ sidebarVisible: false });
    }
  };

  closeSideBarWithNotification = (notif) => {
    this.setState({ sidebarVisible: false, notification: notif });
  };

  showSideBar = (selectedEvent) => {
    this.setState({ sidebarVisible: true, selectedEvent });
  };

  render() {
    const { viewer, removeTravelPlan, data } = this.props;
    const { notification, selectedEvent, sidebarVisible } = this.state;
    const travelPlans = getTravelPlans(viewer.repVisitsTravelPlan);
    const { loading } = data;
    return (
      <SidebarWrapper aria-label="Travel Schedule">
        <PageTitle subTitle="Travel Plan" title="RepVisits" category="Intersect" />

        {travelPlans.length > 0 && (
          <SidebarWrapper.Bar
            visible={sidebarVisible}
            onClose={this.closeSideBar}
            hideCloseButton={false}
          >
            {selectedEvent && (
            <RepVisitsCalendarEventDetailsSideBar
              visible
              onDismissNotification={this.closeSideBar}
              onSave={this.closeSideBarWithNotification}
              event={selectedEvent}
            />
            )}
          </SidebarWrapper.Bar>
        )}
        <SidebarWrapper.Content dimmed={sidebarVisible} onClick={this.closeSideBar}>
          <Container styleName="container">
            {notification}
            <div data-cy="repvisits-travel-plan-description" styleName="heading-container">
              <Header as="h1" styleName="header" id="pageTitle">
                <FormattedMessage {...messages.travelPlan} />
              </Header>
              <FormattedMessage
                {...messages.travelPlanDescription}
                values={{
                  recommendationsLink: (
                    <Link to="/rep-visits/recommendations">
                      <FormattedMessage {...messages.recommendations} />
                    </Link>
                  ),
                }}
              />
            </div>
            { loading && <Loader active />}
            { !loading && !travelPlans.length && (
              <RepVisitsTravelPlanNoResults />
            )}
            { !loading && travelPlans.length > 0 && (
              <div styleName="results-container">
                {travelPlans.map((travelPlan) => (
                  <RepVisitsTravelPlanResults
                    key={travelPlan.state}
                    travelPlan={travelPlan}
                    displayNotification={this.displayNotification}
                    showSideBar={this.showSideBar}
                    viewer={viewer}
                    removeTravelPlan={removeTravelPlan}
                  />
                ))}
              </div>
            )}
          </Container>
        </SidebarWrapper.Content>
      </SidebarWrapper>
    );
  }
}

export default injectIntl(RepVisitsTravelPlan);
